export function keepInBoundsX(element: HTMLElement, padding: number): void {
    var bounds = element.getBoundingClientRect();
    var offset = 0;

    if (bounds.left < padding) {
        offset = Math.abs(bounds.left - padding);
    } else if (bounds.right > window.innerWidth) {
        offset = -(bounds.right - window.innerWidth);
    }

    if (offset != 0) {
        element.style.setProperty("transform", `translate(${offset}px)`);
    }
}